import { Grid, Paper, Typography } from '@mui/material'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { FormHeaderPaper, FormTitleTypography } from '../../../components/CustomStyles/StyledComponents';
import { getAdminAccountData, getAssignableRoles, setSelectedUserId, updateAdminAccount, setLoading, unsetLoading, createAdminAccount } from '../../../store/appAction';
import { useParams } from 'react-router-dom';
import AccountForm from '../../../components/Forms/AccountForm';
import { roleSorter } from '../../../helpers/userHelper';
import { ThemeProvider } from '@emotion/react';
import { mainTheme } from '../../../theme';
import { EDIT, CREATE } from '../../../constants/modes';

const defaultFormData = {
    id: '',
    type: 'farmer',
    email: '',
    firstName: '',
    lastName: '',
    organisationId: '',
    organisationName:'',
    officeId: '',
    licenseId: '',
    isActive: false,
    optInNewsletter: false,
    agreedToTandS: false,
};

const AdminAccount = () => {
    const dispatch = useDispatch();
    let { mode } = useParams();

    const user = useSelector(state => state.auth.user);
    const accountDetails = useSelector(state => state.adminAccount.accountDetails);
    const accountId = useSelector(state => state.adminAccount.selectedUserId);
    const userAssignableRoles = useSelector(state => state.common.assignableRoles);

    const [formData, setFormData] = useState(undefined);

    const validationSchema = Yup.object({
        email: Yup.string("Enter your email")
            .email("Enter a valid email")
            .required("Email is required"),
        firstName: Yup.string("Enter first name").required("First name is required"),
        lastName: Yup.string("Enter last name").required("Last name is required"),
        // office: Yup.string("").required("Office is required"),
        // organisation: Yup.string("").required("Organisation is required"),
    });

    useEffect(() => {
        dispatch(setLoading());
        if (mode === EDIT && accountId != null) {
            dispatch(getAdminAccountData(accountId));
        } else {
            dispatch(setSelectedUserId(null));
            setFormData(structuredClone(defaultFormData));
        }
        dispatch(getAssignableRoles());
        return () => {
            setFormData(structuredClone(defaultFormData));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // TODO change this as we're having to inject settings in here when it should be done in the form.
    useEffect(() => {
        if (mode === CREATE) {
            let formData = structuredClone(defaultFormData)
            let sortedRoles = roleSorter.sort(userAssignableRoles)
            formData.type = sortedRoles[0]?.name || ''
            setFormData(formData);
        }
        dispatch(unsetLoading());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAssignableRoles]);

    useEffect(() => {
        if (mode !== CREATE && accountDetails && !_.isEmpty(accountDetails)) {
            setFormData({
                id: accountDetails?.id,
                type: accountDetails?.roleNames?.[0] || defaultFormData.type,
                email: accountDetails?.email || defaultFormData.email,
                firstName: accountDetails?.firstName || defaultFormData.firstName,
                lastName: accountDetails?.lastName || defaultFormData.lastName,
                organisationId: accountDetails?.organisationId || defaultFormData.organisationId,
                organisationName: accountDetails?.organisation || defaultFormData.organisationName,
                officeId: accountDetails?.officeId || defaultFormData.officeId,
                license: accountDetails?.licenseId || defaultFormData.licenseId,
                active: accountDetails?.isActive || defaultFormData.isActive,
                newsletter: accountDetails?.optInNewsletter || defaultFormData.optInNewsletter,
                agreement: accountDetails?.agreedToTandS || defaultFormData.agreedToTandS,
            });
            dispatch(unsetLoading());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountDetails]);

    const handleSubmit = data => {
        dispatch(setLoading());
        if (mode === EDIT && accountId != null) {
            dispatch(updateAdminAccount(data));
        } else {
            dispatch(createAdminAccount(data));
        }
    };

    return (
        <ThemeProvider theme={mainTheme}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <FormHeaderPaper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                        <FormTitleTypography variant="h5" component="div">
                            {(mode === EDIT && accountId) ? 'Edit' : 'Create'} User
                        </FormTitleTypography>
                        <Typography variant="body2" component="p">
                            {' Create or modify your account details.'}
                        </Typography>
                    </FormHeaderPaper>
                </Grid>
                <Grid item md={12} >
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', }}>
                        {formData &&
                            <Formik enableReinitialize initialValues={formData}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {props => <AccountForm {...props} role={user?.role} mode={mode} />}
                            </Formik>}
                    </Paper>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}

export default AdminAccount